export const FORM_TYPES = {
  inputNumber: "inputNumber",
  radioTabs: "radioTabs",
  radioButtons: "radioButtons",
  tp53VafInput: "tp53VafInput",
  hemoglobinInput: "hemoglobinInput",
};
